// extracted by mini-css-extract-plugin
export default {"container":"diagnosis-info_container__G-9BL","icon":"diagnosis-info_icon__I7sxB","description":"diagnosis-info_description__8NRFT"};